import { render, staticRenderFns } from "./ProcessoAprovacao.vue?vue&type=template&id=6940ac40&scoped=true"
import script from "./ProcessoAprovacao.vue?vue&type=script&lang=js"
export * from "./ProcessoAprovacao.vue?vue&type=script&lang=js"
import style0 from "./ProcessoAprovacao.vue?vue&type=style&index=0&id=6940ac40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6940ac40",
  null
  
)

export default component.exports